import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Fab,
  List,
  ListItem,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import { useCookieConsentContext } from "@use-cookie-consent/react";
import React, { useState } from "react";
import { BiCookie } from "react-icons/bi";
import CookiesComp from "./cookies";
import cookies from "js-cookie";

interface IProps {
  showFab?: boolean;
  onClick?: () => void;
}

const CookieDialog: React.FC<IProps> = ({ showFab, onClick }) => {
  const [display, setDisplay] = useState(false);
  const { acceptAllCookies, declineAllCookies } = useCookieConsentContext();

  const optOut = () => {
    declineAllCookies();
  };

  const acceptAll = () => {
    acceptAllCookies();
    try {
      cookies.set("cookie-consent", "accepted", {
        path: "/",
        // in a year
        expires: new Date(Date.now() + 31536000000),
      });
    } catch (e) {
      console.error(e);
    }
  };

  const handleClose = () => {
    // set cookies

    try {
      cookies.set("cookie-consent", "accepted", {
        path: "/",
        // in a year
        expires: new Date(Date.now() + 31536000000),
      });
    } catch (e) {
      console.error(e);
    }
    setDisplay(false);
  };

  return (
    <>
      {showFab && (
        <Box
          sx={(theme) => ({
            [theme.breakpoints.down("md")]: { display: "none" },
          })}
        >
          <Tooltip
            title={<Typography>Nastavení Cookies</Typography>}
            arrow
            placement="right"
          >
            <Fab
              color="primary"
              aria-label="cookies"
              onClick={() => setDisplay(true)}
              sx={(theme) => ({
                position: "fixed",
                bottom: 16,
                left: 16,
              })}
            >
              <BiCookie size={34} />
            </Fab>
          </Tooltip>
        </Box>
      )}
      <Button
        onClick={() => {
          onClick && onClick();
          setDisplay(true);
        }}
        variant="text"
        sx={{ color: "inherit" }}
      >
        Změnit nastavení cookies
      </Button>
      <Dialog open={display} onClose={handleClose} fullWidth maxWidth="md">
        <DialogTitle>
          <Typography
            sx={{ fontSize: 24, fontWeight: "bold", marginBottom: 2 }}
          >
            Nastavení cookies
          </Typography>
        </DialogTitle>
        <DialogContent>
          {/* <Typography variant="body2" sx={{ padding: 2 }}>
            Pomocí cookies vám umožňujeme efektivně se pohybovat po stránce a
            využívat některé funkce. Detailní informace o všech cookies najdete
            níže v jednotlivých kategoriích souhlasu.
            <br />
            Cookies označené jako „Nezbytné“ se ukládají ve vašem prohlížeči,
            protože jsou nutné ke zpřístupnění základních funkcí stránky.
            Používáme také cookies třetí strany, které nám umožňují analyzovat,
            jak tuto stránku využíváte, ukládat vaše předvolby a poskytovat vám
            obsah a reklamy, které jsou pro vás relevantní. Tyto cookies se
            budou ukládat ve vašem prohlížeči výhradně až poté, co to
            odsouhlasíte.
            <br />
            Můžete se rozhodnout, že některé nebo veškeré tyto cookies zapnete
            či vypnete, ale vypnutí některých z nich může mít vliv na vaše
            prohlížení.
          </Typography> */}
          <Box
            sx={(theme) => ({
              marginTop: 2,
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              [theme.breakpoints.down("md")]: { display: "none" },
            })}
          >
            <Button color="error" onClick={optOut}>
              Odebrat vše
            </Button>
            <Button color="primary" onClick={acceptAll}>
              Přijmout vše
            </Button>
          </Box>
          <List>
            <CookieOption
              text="Nezbytné cookies"
              description={`Nezbytné soubory cookie jsou zásadní pro základní funkce webu a web bez nich nebude fungovat zamýšleným způsobem.\n\nTyto soubory cookie neukládají žádná osobní identifikační data.`}
              type="necessary"
              disabled
            />
            <CookieOption
              text="Cookies třetích stran"
              description={`Soubory cookies třetích stran slouží k zobrazování obsahu z jiných webových stránek, jako jsou videa nebo sociální sítě.\n\nTyto soubory cookie mohou být používány pro sledování vašeho chování na těchto webových stránkách.`}
              type="thirdParty"
            />
            <CookieOption
              text="Analytické cookies"
              description={`Analytické soubory cookie se používají k pochopení interakce návštěvníků s webem. Tyto soubory cookie pomáhají poskytovat informace o metrikách počet návštěvníků, míru okamžitého opuštění, zdroj provozu atd.`}
              type="statistics"
            />
          </List>
          <Box
            sx={(theme) => ({ [theme.breakpoints.down("md")]: { padding: 2 } })}
          >
            <Divider />
            <Box
              sx={(theme) => ({
                display: "flex",
                flexDirection: "column",
                paddingTop: 1,
                gap: 1,
                [theme.breakpoints.up("md")]: { display: "none" },
              })}
            >
              <Button color="error" onClick={optOut}>
                Odebrat vše
              </Button>
              <Button color="primary" onClick={acceptAll}>
                Přijmout vše
              </Button>
              <Button color="primary" variant="contained" onClick={handleClose}>
                Uložit preference
              </Button>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions
          sx={(theme) => ({
            [theme.breakpoints.down("md")]: { display: "none" },
            padding: 2,
          })}
        >
          <Button color="primary" variant="contained" onClick={handleClose}>
            Uložit preference
          </Button>
        </DialogActions>
      </Dialog>

      <CookiesComp onClickEdit={() => setDisplay(true)} />
    </>
  );
};

export default CookieDialog;

interface Props {
  text: string;
  description?: string;
  disabled?: boolean;
  type: "firstParty" | "thirdParty" | "statistics" | "necessary";
}

const CookieOption: React.FC<Props> = ({
  text,
  disabled,
  type,
  description,
}) => {
  const { acceptCookies, consent } = useCookieConsentContext();

  const handleAccept = (event: React.ChangeEvent<HTMLInputElement>) => {
    acceptCookies({
      ...consent,
      [type]: event.target.checked,
    });

    try {
      cookies.set(
        "cookie-consent",
        "accepted",

        {
          path: "/",
          // in a year
          expires: new Date(Date.now() + 31536000000),
        }
      );
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <ListItem>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
          <Typography sx={{ fontWeight: "bold" }}>{text}</Typography>
          {description && (
            <Typography variant="body2">{description}</Typography>
          )}
        </Box>
        <Switch
          disabled={disabled}
          checked={consent[type]}
          onChange={handleAccept}
        />
      </Box>
    </ListItem>
  );
};
